import * as React from 'react';
import { SVGProps } from 'react';

const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#mail_svg__a)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.136 6.5H4.864L12 12.05l7.136-5.55ZM3.5 7.339V17.5h17V7.339L12 13.95 3.5 7.34ZM2 19V5h20v14H2Z'
        fill='#000'
      />
    </g>
    <defs>
      <clipPath id='mail_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMail;
